import { render, staticRenderFns } from "./RevenueItems.vue?vue&type=template&id=0313eec4&scoped=true&"
import script from "./RevenueItems.vue?vue&type=script&lang=js&"
export * from "./RevenueItems.vue?vue&type=script&lang=js&"
import style0 from "./RevenueItems.vue?vue&type=style&index=0&id=0313eec4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0313eec4",
  null
  
)

export default component.exports